import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
  selector: "app-accordion-tab-custom",
  template: `
  <p-accordionTab [(selected)]="isActive" class="p-accordion-tab">
    <p-header>
        <ng-content select="[accordion-header]"></ng-content>
    </p-header>
    <ng-content select="[accordion-content]"></ng-content>
  </p-accordionTab>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionTabCustomComponent {
  @Input() isActive = false;
}
